import axios from "axios";
import { handleRequestError, memoizePromiseFn } from "../../requests";

export const GetJDEStuckRecords = async () => {
  const results = await axios.get(`/LiquidBilling/GetJDEStuckRecords`).catch(handleRequestError);
  return results.data;
};

export const resendInvoice = async (billing) => {
  const results = await axios.post('/LiquidBilling/resendInvoice', billing).catch(handleRequestError);
  return results.data;
};

export const updateValues = async (billing) => {
  const results = await axios.put('/LiquidBilling/updateValues', billing).catch(handleRequestError);
  return results.data;
};

export const getMonthlyStats = async () => {
  const results = await axios.get(`/LiquidBilling/GetMonthlyStats`).catch(handleRequestError);
  return results.data;
};
export const getPendingErrorInvoices = async () => {
  const results = await axios.get(`/LiquidBilling/GetErrorInvoices`).catch(handleRequestError);
  return results.data;
};

export const getPendingCreditInvoices = async () => {
  const results = await axios.get(`/LiquidBilling/GetLiquidBillingCreditList`).catch(handleRequestError);
  return results.data;
};

export const getPendingDeliveryInvoices = async () => {
  const results = await axios.get(`/LiquidBilling/GetPendingDeliveries`).catch(handleRequestError);
  return results.data;
};

export const getPendingManualInvoices = async () => {
  const results = await axios.get(`/LiquidBilling/GetPendingManualUpload`).catch(handleRequestError);
  return results.data;
};

export const getPendingAutomaticInvoices = async () => {
  const results = await axios.get(`/LiquidBilling/GetPendingAutomaticUpload`).catch(handleRequestError);
  return results.data;
};


export const UnLinkCreditInvoice = async ({ billingId, creditInvoiceIdToLink }) => {
  const results = await axios.put('/LiquidBilling/UnLinkCreditInvoice', { billingId, creditInvoiceIdToLink }).catch(handleRequestError);
  return results.data;
};
export const LinkCreditInvoice = async ({ billingId, creditInvoiceIdToLink }) => {
  const results = await axios.put('/LiquidBilling/LinkCreditInvoice', { billingId, creditInvoiceIdToLink }).catch(handleRequestError);
  return results.data;
};

//updatePsig
export const updatePsig = async (billing) => {
  const results = await axios.put('/LiquidBilling/updatePsig', billing).catch(handleRequestError);
  return results.data;
}

export const UpdateLiquidBillingInvoice = async (billing) => {
  const results = await axios.put('/LiquidBilling/UpdateBilling', billing).catch(handleRequestError);
  return results.data;
}
export const UploadLiquidBillingInvoices = async (billing) => {
  const results = await axios.post('/LiquidBilling/UploadInvoicesToJDE', billing).catch(handleRequestError);
  return results.data;
}

export const BypassInvoiceFromInvoice = async (billing) => {
  const results = await axios.post('/LiquidBilling/BypassInvoiceFromInvoice', billing).catch(handleRequestError);
  return results.data;
}

export const InsertBilling = async (billing) => {
  const results = await axios.post('/LiquidBilling/InsertBilling', billing).catch(handleRequestError);
  return results.data;
}

export const getLiquidBillingInvoices = async (queryDefinition) => {
  const results = await axios.post(`/LiquidBilling/GetLiquidBillingList`, queryDefinition).catch(handleRequestError);
  return results.data;
}
export const getLiquidBillingHeader = async (billingId) => {
  const results = await axios.get(`/LiquidBilling/GetLiquidBillingHeader/${billingId}`).catch(handleRequestError);
  return results.data;
}

export const getRecentLiquidDeliveries = async (customerId) => {
  const results = await axios.get(`/LiquidBilling/getRecentLiquidDeliveries/${customerId}`).catch(handleRequestError);
  return results.data;
}



export const createLiquidBillingTransfer = async (billing) => {
  const results = await axios.post(`/LiquidBilling/CreateTransferRequest`, billing).catch(handleRequestError);
  return results.data;
}
export const getUnlinkedCreditInvoices = async () => {
  const results = await axios.get(`/LiquidBilling/GetUncreditedInvoices`).catch(handleRequestError);
  return results.data;
}

export const deleteInvoice = async (invoiceId) => {
  const results = await axios.delete(`/LiquidBilling/DeleteInvoice/${invoiceId}`).catch(handleRequestError);
  return results.data;
};
// /PreAuthorizeCreditCard
export const PreAuthorizeCreditCard = async (billingId) => {
  const results = await axios.get(`/LiquidBilling/PreAuthorizeCreditCard/${billingId}`).catch(handleRequestError);
  return results.data;
};

export const getBillingHeader = async (billingId) => {
  const results = await axios.get(`/LiquidBilling/getBillingHeader/${billingId}`).catch(handleRequestError);
  return results.data;
};

export const reverseBilling = async (reverse) => {
  const results = await axios.post(`/LiquidBilling/reverseBilling`, reverse).catch(handleRequestError);
  return results.data;
};

export const uploadInvoicesJDEDTO = async (invoice) => {
  const results = await axios.post(`/LiquidBilling/UploadInvoicesToJDE`, invoice).catch(handleRequestError);
  return results.data;
};

export const SendReport = async (report) => {
  const results = await axios.post('/LiquidBilling/SendReport', report).catch(handleRequestError);
  return results.data;
};
export const downloadReport = async (report) => {
  const results = await axios.post('/LiquidBilling/DownloadReport', report, { responseType: 'blob' }).catch(handleRequestError);

  const url = window.URL.createObjectURL(new Blob([results.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', report.filename);
  document.body.appendChild(link);
  link.click();
};
export const GetJDEErrors = async (billing) => {
  const results = await axios.get('/LiquidBilling/GetJDEErrors').catch(handleRequestError);
  return results.data;
}
export const GetUnbilledInvoices = async (billing) => {
  const results = await axios.get('/LiquidBilling/GetUnbilledInvoices').catch(handleRequestError);
  return results.data;
}

export const UpdateBilling = async (billing) => {
  const results = await axios.put('/LiquidBilling/UpdateBilling', billing).catch(handleRequestError);
  return results.data;
}